import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { GROUPS, TIERS, priceLabel } from "../lib/packages";

// Startpagina (build 2.4): wat je ziet als je niet bent ingelogd. Inloggen zit in het
// openingsblok; de pakketknoppen gaan naar /aanmelden met het gekozen pakket.

var CONTACT_EMAIL = "floris.noordam@gmail.com";

var CSS = `
.lp{font-family:'Archivo',system-ui,sans-serif;color:#1C1B19;background:#F5F3EE;min-height:100vh}
.lp a{color:#1A2744}
.lp-wrap{max-width:1200px;margin:0 auto;padding:0 24px}
.lp-kick{font-size:12px;letter-spacing:1.5px;font-weight:700;color:#6B675F;text-transform:uppercase;margin-bottom:12px}
.lp-h2{font-size:36px;line-height:1.15;font-weight:800;margin-bottom:12px;letter-spacing:-0.5px}
.lp-lead{font-size:17px;line-height:1.6;color:#4A4741}
.lp-card{background:#fff;border:1px solid #E6E2D9;border-radius:16px}
.lp-btnp{display:inline-flex;align-items:center;justify-content:center;min-height:46px;padding:0 22px;border-radius:10px;background:#1A2744;color:#fff !important;font-weight:700;font-size:15px;text-decoration:none;border:none;cursor:pointer}
.lp-btnp:hover{background:#0E1630}
.lp-btnp:disabled{opacity:.7;cursor:default}
.lp-btns{display:inline-flex;align-items:center;justify-content:center;min-height:46px;padding:0 22px;border-radius:10px;background:#fff;color:#1C1B19 !important;font-weight:700;font-size:15px;text-decoration:none;border:1px solid #D6D1C6;cursor:pointer}
.lp-btns:hover{border-color:#1C1B19}
.lp-btnw{display:inline-flex;align-items:center;justify-content:center;min-height:46px;border-radius:10px;background:#fff;color:#1A2744 !important;font-weight:700;font-size:15px;text-decoration:none}
.lp-navl{color:#1C1B19 !important;text-decoration:none;font-size:15px;font-weight:600;padding:6px 0;border-bottom:2px solid transparent}
.lp-navl:hover{border-bottom-color:#CFCAC0}
.lp-navl.active{border-bottom-color:#1A2744}
.lp-mlink{display:block;padding:12px 16px;border-radius:10px;color:#1C1B19 !important;text-decoration:none;font-size:16px;font-weight:600}
.lp-mlink.active{background:#fff}
.lp-inp{width:100%;min-height:46px;padding:0 14px;border-radius:10px;border:1px solid #CFCAC0;font-size:16px;background:#fff;color:#1C1B19;outline:none}
.lp-inp:focus{border-color:#1A2744}
.lp-lbl{display:block;font-size:13px;font-weight:600;color:#4A4741;margin-bottom:6px}
.lp-tick{display:flex;gap:10px;align-items:flex-start;font-size:15px;line-height:1.45}
.lp-sec{padding:88px 0}
.lp-white{background:#fff;border-top:1px solid #E2DED5;border-bottom:1px solid #E2DED5}
.lp-grid3{display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));gap:20px}
.lp-hero{display:flex;gap:56px;align-items:center;flex-wrap:wrap}
.lp-h1{font-size:56px;line-height:1.05;font-weight:800;margin-bottom:20px;letter-spacing:-1.2px}
.lp-chip{padding:6px 12px;border-radius:999px;font-size:13px;font-weight:700}
.lp-bar{width:20px;height:8px;border-radius:4px;display:inline-block}
.lp-faq{border-top:1px solid #E2DED5;padding:20px 0}
.lp-faq summary{font-size:18px;font-weight:700;cursor:pointer}
.lp-faq p{font-size:15px;line-height:1.6;color:#4A4741;margin-top:12px}
@media (max-width:760px){
  .lp-navlinks{display:none !important}
  .lp-menubtn{display:flex !important}
  .lp-sec{padding:56px 0}
  .lp-h1{font-size:36px;letter-spacing:-0.8px}
  .lp-h2{font-size:28px}
  .lp-hero{gap:32px}
  .lp-wrap{padding:0 16px}
}
`;

function Check({ color, size }) {
  var s = size || 18;
  return (
    <svg width={s} height={s} viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flex: "none", marginTop: 2 }}><path d="M5 12l5 5 9-10" /></svg>
  );
}
function Plus({ color }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" style={{ flex: "none", marginTop: 2 }}><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
  );
}
function Logo({ size, dark }) {
  var s = size || 30;
  return (
    <svg width={s} height={s} viewBox="0 0 30 30" aria-hidden="true"><circle cx="15" cy="15" r="13" fill={dark ? "#F5F3EE" : "#1A2744"} /><path d="M5 9c6 3 6 9 0 12M25 9c-6 3-6 9 0 12" stroke={dark ? "#1A2744" : "#F5F3EE"} strokeWidth="2" fill="none" strokeLinecap="round" /></svg>
  );
}
function Bars({ colors }) {
  return <div style={{ display: "flex", gap: 4 }}>{colors.map(function (c, i) { return <span key={i} className="lp-bar" style={{ background: c }} />; })}</div>;
}

function LoginCard() {
  var { login, resetPassword } = useAuth();
  var [email, setEmail] = useState("");
  var [pw, setPw] = useState("");
  var [err, setErr] = useState("");
  var [info, setInfo] = useState("");
  var [busy, setBusy] = useState(false);
  var [mode, setMode] = useState("login");

  async function submit(e) {
    e.preventDefault();
    setErr(""); setInfo(""); setBusy(true);
    try {
      if (mode === "reset") {
        await resetPassword(email.trim());
        setInfo("Als dit e-mailadres bij ons bekend is, ontvang je binnen enkele minuten een mail met een link om een nieuw wachtwoord in te stellen. Kijk ook even in je spam.");
      } else {
        await login(email.trim(), pw);
      }
    } catch (e2) {
      console.error(e2);
      if (mode === "reset") setErr(e2.code === "auth/invalid-email" ? "Dit is geen geldig e-mailadres." : "Versturen mislukt (" + (e2.code || e2.message) + ").");
      else setErr("Inloggen mislukt. Controleer je e-mailadres en wachtwoord.");
    }
    setBusy(false);
  }

  return (
    <form id="inloggen" onSubmit={submit} className="lp-card" style={{ flex: "1 1 320px", maxWidth: 400, padding: 32, boxShadow: "0 24px 60px rgba(28,27,25,0.08)" }}>
      <h2 style={{ fontSize: 22, fontWeight: 800, marginBottom: 4 }}>{mode === "reset" ? "Wachtwoord vergeten" : "Inloggen"}</h2>
      <p style={{ fontSize: 14, color: "#6B675F", marginBottom: 22 }}>{mode === "reset" ? "We sturen je een link om een nieuw wachtwoord in te stellen" : "Met je trainersaccount"}</p>
      <label className="lp-lbl" htmlFor="lp-em">E-mailadres</label>
      <input className="lp-inp" id="lp-em" type="email" autoComplete="email" required value={email} onChange={function (e) { setEmail(e.target.value); }} placeholder="naam@voorbeeld.nl" style={{ marginBottom: 14 }} />
      {mode === "login" && <>
        <label className="lp-lbl" htmlFor="lp-pw">Wachtwoord</label>
        <input className="lp-inp" id="lp-pw" type="password" autoComplete="current-password" required value={pw} onChange={function (e) { setPw(e.target.value); }} style={{ marginBottom: 8 }} />
      </>}
      <div style={{ textAlign: "right", marginBottom: 18 }}>
        <button type="button" onClick={function () { setMode(mode === "reset" ? "login" : "reset"); setErr(""); setInfo(""); }} style={{ background: "none", border: "none", padding: 0, fontSize: 13, color: "#6B675F", textDecoration: "underline", cursor: "pointer" }}>{mode === "reset" ? "← Terug naar inloggen" : "Wachtwoord vergeten?"}</button>
      </div>
      {err && <p style={{ color: "#B83232", fontSize: 13, marginBottom: 10 }}>{err}</p>}
      <button className="lp-btnp" type="submit" disabled={busy} style={{ width: "100%" }}>{busy ? "Bezig..." : (mode === "reset" ? "Stuur resetlink" : "Inloggen")}</button>
      {info && <p style={{ color: "#2F7D47", fontSize: 13, marginTop: 12, lineHeight: 1.5 }}>{info}</p>}
      <p style={{ marginTop: 20, paddingTop: 18, borderTop: "1px solid #E2DED5", fontSize: 14, color: "#6B675F", textAlign: "center" }}>Nog geen account? <Link to="/pakketten" style={{ fontWeight: 700 }}>Kies een pakket</Link></p>
    </form>
  );
}

function PackageCard({ group, tier }) {
  var plus = tier.key === "plus";
  var key = group.key + "-" + tier.key;
  var sub = plus ? "#C9D2E3" : "#6B675F";
  return (
    <div className={plus ? "" : "lp-card"} style={{ padding: 24, display: "flex", flexDirection: "column", gap: 16, background: plus ? "#1A2744" : "#fff", color: plus ? "#fff" : "#1C1B19", borderRadius: 16 }}>
      <Bars colors={plus ? group.bars.map(function (c) { return c === "#6A4BB0" ? "#B7A3E6" : c; }) : group.bars} />
      <div>
        <h4 style={{ fontSize: 20, fontWeight: 800, marginBottom: 4 }}>{group.label} {tier.label}</h4>
        <p style={{ fontSize: 14, color: sub }}>{group.sub}</p>
      </div>
      <div><span style={{ fontSize: 26, fontWeight: 800 }}>{priceLabel(key)}</span><span style={{ fontSize: 14, color: sub }}> per seizoen</span></div>
      <div style={{ display: "flex", flexDirection: "column", gap: 10, flex: 1, paddingTop: 16, borderTop: "1px solid " + (plus ? "#34446A" : "#E2DED5") }}>
        {tier.items.map(function (it) { return <div key={it} className="lp-tick"><Check color={plus ? "#E8C12E" : "#2F7D47"} />{it}</div>; })}
        {(tier.extras || []).map(function (it) { return <div key={it} className="lp-tick" style={{ fontWeight: 700 }}><Plus color="#E8C12E" />{it}</div>; })}
      </div>
      <Link to={"/aanmelden?pakket=" + key} className={plus ? "lp-btnw" : "lp-btns"}>Aanmelden</Link>
    </div>
  );
}

function Person({ initials, name, role, text }) {
  return (
    <div className="lp-card" style={{ padding: 24, display: "flex", flexDirection: "column", gap: 14 }}>
      <div style={{ width: 88, height: 88, borderRadius: "50%", background: "#E7E3DA", color: "#1A2744", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26, fontWeight: 800 }}>{initials}</div>
      <div><div style={{ fontSize: 18, fontWeight: 800 }}>{name}</div><div style={{ fontSize: 14, color: "#6B675F" }}>{role}</div></div>
      <p style={{ fontSize: 14, lineHeight: 1.55, color: "#4A4741" }}>{text}</p>
    </div>
  );
}

var FAQ = [
  { q: "Werkt het op mijn telefoon?", a: "Ja. Seizoensplan is gemaakt om op de baan te gebruiken, op je telefoon en op je laptop. Je hoeft niets te installeren." },
  { q: "Kan ik het eerst bekijken?", a: "Binnenkort kun je op de pagina Demo zelf door een basisversie van de app klikken, zonder account." },
  { q: "Wanneer staat het nieuwe seizoen klaar?", a: "We proberen de seizoensplannen zo vroeg mogelijk af te hebben: in maart voor het zomerseizoen en in september voor het winterseizoen." },
  { q: "Kan mijn hele club meedoen?", a: "Ja, met een teamlicentie. Neem contact op, dan maken we een voorstel." },
  { q: "Hoe zit het met opzeggen?", a: "Opzeggen is niet nodig. Je betaalt per seizoen. Wil je het volgende seizoen geen gebruik maken van de seizoensplannen, dan hoef je niets te doen." },
];

// De losse pagina's van de website (build 2.4). De paden staan ook in App.js als routes en
// zijn in functions/index.js gereserveerd, zodat geen club ze als webadres kan krijgen.
export var LANDING_PAGES = [
  { key: "hoe", path: "/hoe-het-werkt", label: "Hoe het werkt" },
  { key: "voorbeeld", path: "/demo", label: "Demo" },
  { key: "pakketten", path: "/pakketten", label: "Pakketten" },
  { key: "wij", path: "/over-ons", label: "Wie zijn wij" },
  { key: "vragen", path: "/vragen", label: "Vragen" },
];

// Naar het inlogformulier scrollen en de cursor in het e-mailveld zetten.
function goToLogin() {
  var form = document.getElementById("inloggen");
  if (!form) return false;
  form.scrollIntoView({ behavior: "smooth", block: "center" });
  var em = document.getElementById("lp-em");
  if (em) setTimeout(function () { try { em.focus({ preventScroll: true }); } catch (e) { em.focus(); } }, 300);
  return true;
}

function Header() {
  var [open, setOpen] = useState(false);
  var loc = useLocation();
  var navigate = useNavigate();
  // De knop Inloggen: op de startpagina naar het formulier; elders eerst naar de startpagina.
  function onLogin(e) {
    e.preventDefault();
    setOpen(false);
    if (loc.pathname === "/" && goToLogin()) return;
    navigate("/", { state: { login: true } });
  }
  return (
    <header style={{ borderBottom: "1px solid #E2DED5", position: "relative" }}>
      <div className="lp-wrap" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, minHeight: 72 }}>
        <Link to="/" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none", color: "#1C1B19" }}>
          <Logo />
          <span style={{ fontSize: 20, fontWeight: 800, letterSpacing: -0.3 }}>Seizoensplan</span>
        </Link>
        <nav aria-label="Hoofdmenu" style={{ display: "flex", alignItems: "center", gap: 24 }}>
          <span className="lp-navlinks" style={{ display: "flex", gap: 24 }}>
            {LANDING_PAGES.map(function (p) { return <NavLink key={p.key} className="lp-navl" to={p.path}>{p.label}</NavLink>; })}
          </span>
          <Link className="lp-btns" to="/" onClick={onLogin} style={{ minHeight: 40, padding: "0 16px" }}>Inloggen</Link>
          <button type="button" className="lp-menubtn" aria-expanded={open} aria-label={open ? "Menu sluiten" : "Menu openen"} onClick={function () { setOpen(!open); }}
            style={{ display: "none", width: 44, height: 44, borderRadius: 10, border: "1px solid #D6D1C6", background: "#fff", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
            <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="#1C1B19" strokeWidth="2" strokeLinecap="round">{open ? <><path d="M6 6l12 12" /><path d="M18 6L6 18" /></> : <><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h16" /></>}</svg>
          </button>
        </nav>
      </div>
      {open && (
        <nav aria-label="Menu" style={{ position: "absolute", left: 0, right: 0, top: "100%", background: "#F5F3EE", borderBottom: "1px solid #E2DED5", padding: "8px 8px 12px", zIndex: 20, boxShadow: "0 12px 30px rgba(0,0,0,.08)" }}>
          {LANDING_PAGES.map(function (p) { return <NavLink key={p.key} className="lp-mlink" to={p.path} onClick={function () { setOpen(false); }}>{p.label}</NavLink>; })}
        </nav>
      )}
    </header>
  );
}

// "Hoe het werkt" (build 2.6): vier onderdelen, elk met een plaatje, een korte inleiding en
// een paar uitgelichte functies. Op de laptop om en om links/rechts, op de telefoon onder elkaar.
function lpStar(on) { return <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.2l2.7 5.6 6.1.8-4.5 4.2 1.1 6-5.4-2.9-5.4 2.9 1.1-6-4.5-4.2 6.1-.8z" fill={on ? "#E8C12E" : "none"} stroke={on ? "#C9A20F" : "#A39E94"} strokeWidth="1.8" strokeLinejoin="round" /></svg>; }
var LIB_CARDS = [["#B83232", "Forehand op richting", "Rood · 55 min", true], ["#6A4BB0", "Service en return", "Volwassenen · 60 min", true], ["#2F7D47", "Netspel in tweetallen", "Groen · 50 min", false]];

function SeasonVisual() {
  return (
    <div style={{ background: "#F5F3EE", borderRadius: 16, padding: 20, display: "flex", flexDirection: "column", gap: 8 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: "#6B675F", letterSpacing: 1 }}>WINTERSEIZOEN</div>
        <div className="lp-card" style={{ padding: "10px 12px", fontSize: 14, fontWeight: 600 }}>Week 1 · Forehand enkelspel</div>
        <div className="lp-card" style={{ padding: "10px 12px", fontSize: 14, fontWeight: 600 }}>Week 2 · Backhand dubbelspel</div>
        <div style={{ padding: "10px 12px", display: "flex", justifyContent: "space-between", fontSize: 14, fontWeight: 700, background: "#1A2744", color: "#fff", borderRadius: 16 }}><span>Week 3 · Oplopen netspel dubbelspel</span><span style={{ flex: "none", marginLeft: 8 }}>Nu</span></div>
        <div className="lp-card" style={{ padding: "10px 12px", fontSize: 14, fontWeight: 600, color: "#6B675F" }}>Week 4 · Service plaatsing enkelspel</div>
      </div>
  );
}
function WeekVisual() {
  return (
    <div style={{ background: "#F5F3EE", borderRadius: 16, padding: 20, display: "flex", flexDirection: "column", gap: 10 }}>
        <div style={{ display: "flex", gap: 6 }}>
          {["#B83232", "#B85A12", "#2F7D47", "#E8C12E", "#6A4BB0"].map(function (c, i) {
            return <span key={c} style={{ flex: 1, height: 30, borderRadius: 8, background: c, outline: i === 1 ? "3px solid #1C1B19" : "none", outlineOffset: 2 }} />;
          })}
        </div>
        <div className="lp-card" style={{ padding: 14, flex: 1, display: "flex", flexDirection: "column", gap: 8 }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: "#B85A12" }}>ORANJE · WEEK 3</div>
          {[90, 75, 82, 60].map(function (w) { return <div key={w} style={{ height: 10, borderRadius: 5, background: "#E7E3DA", width: w + "%" }} />; })}
        </div>
      </div>
  );
}
function DrillVisual() {
  return (
    <div style={{ background: "#F5F3EE", borderRadius: 16, padding: 20, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <svg viewBox="0 0 220 180" width="100%" height="100%" role="img" aria-label="Schets van een oefening op een tennisbaan">
          <rect x="20" y="10" width="180" height="160" rx="4" fill="#3E7D5A" />
          <rect x="40" y="10" width="140" height="160" fill="none" stroke="#fff" strokeWidth="2" />
          <line x1="20" y1="90" x2="200" y2="90" stroke="#fff" strokeWidth="3" />
          <line x1="40" y1="50" x2="180" y2="50" stroke="#fff" strokeWidth="2" />
          <line x1="40" y1="130" x2="180" y2="130" stroke="#fff" strokeWidth="2" />
          <line x1="110" y1="50" x2="110" y2="130" stroke="#fff" strokeWidth="2" />
          <circle cx="80" cy="150" r="7" fill="#1A2744" stroke="#fff" strokeWidth="2" />
          <circle cx="140" cy="30" r="7" fill="#B85A12" stroke="#fff" strokeWidth="2" />
          <path d="M80 142 Q120 80 140 38" stroke="#E8C12E" strokeWidth="2.5" fill="none" strokeDasharray="5 4" />
          <path d="M85 160 L130 160" stroke="#fff" strokeWidth="2" fill="none" strokeDasharray="3 3" />
          <polygon points="150,155 156,166 144,166" fill="#E8822E" />
          <polygon points="60,110 66,121 54,121" fill="#E8822E" />
        </svg>
      </div>
  );
}
function LibVisual() {
  var star = lpStar, cards = LIB_CARDS;
  return (
    <div style={{ background: "#F5F3EE", borderRadius: 16, padding: 20, display: "flex", flexDirection: "column", gap: 10 }} aria-hidden="true">
      <div style={{ display: "flex", gap: 18, borderBottom: "1px solid #E2DED5", fontSize: 14, fontWeight: 700, color: "#6B675F" }}>
        <span style={{ padding: "0 2px 8px", borderBottom: "3px solid #1A2744", color: "#1A2744", fontWeight: 800 }}>Lessen</span>
        <span style={{ padding: "0 2px 8px" }}>Oefeningen</span>
        <span style={{ padding: "0 2px 8px" }}>Notities</span>
      </div>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "5px 11px", borderRadius: 999, border: "1px solid #C9A20F", background: "#FFF6D6", color: "#7A5C00", fontSize: 12, fontWeight: 800 }}>{star(true)}Favorieten</span>
        <span style={{ padding: "5px 11px", borderRadius: 999, border: "1px solid #E2DED5", background: "#fff", fontSize: 12, fontWeight: 600, color: "#4A4740" }}>Forehand</span>
        <span style={{ padding: "5px 11px", borderRadius: 999, border: "1px solid #E2DED5", background: "#fff", fontSize: 12, fontWeight: 600, color: "#4A4740" }}>Dubbelspel</span>
      </div>
      {cards.map(function (c) {
        return (
          <div key={c[1]} className="lp-card" style={{ padding: "10px 12px", display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ width: 18, height: 18, borderRadius: "50%", background: c[0], flex: "none" }} />
            <span style={{ flex: 1, minWidth: 0 }}><span style={{ display: "block", fontSize: 14, fontWeight: 800 }}>{c[1]}</span><span style={{ display: "block", fontSize: 12, color: "#6B675F" }}>{c[2]}</span></span>
            {star(c[3])}
          </div>
        );
      })}
    </div>
  );
}

var HOE_ROWS = [
  { title: "Seizoensoverzicht", visual: SeasonVisual,
    intro: "Het hele seizoen per niveau op een rij, met een thema per week.",
    features: [
      ["Een thema per week", "Elke week een duidelijk thema, zoals forehand of dubbelspel, met de focuspunten en aanpassingen per groep erbij."],
      ["Per niveau opgebouwd", "Rood, oranje, groen, geel en volwassenen, elk met een eigen opbouw over het seizoen."],
    ] },
  { title: "Weekoverzicht", visual: WeekVisual,
    intro: "Wat je deze week op de baan doet, voor elke groep.",
    features: [
      ["Veeg tussen de kleuren", "Alle groepen van deze week bij elkaar, zonder te zoeken of te scrollen."],
      ["Alle oefeningen per les", "Van warming-up tot wedstrijdvorm, alles overzichtelijk onder elkaar."],
    ] },
  { title: "Oefeningen met uitleg", visual: DrillVisual,
    intro: "Elke oefening met uitgebreide uitleg.",
    features: [
      ["Hulp op de baan", "Groepsaanpassingen, accenten en extra oefeningen maken het je makkelijker op de baan."],
      ["Tekening en animatie", "Met Plus ook een schematische tekening of animatie als visueel hulpmiddel."],
    ] },
  { title: "Bibliotheek", visual: LibVisual,
    intro: "Alles wat je los wilt pakken op één plek: lessen, oefeningen en je eigen notities.",
    features: [
      ["Losse lessen", "Pak een les uit het seizoensplan, van een collega of van jezelf. Filter op kleur en op type, zoals forehand of dubbelspel."],
      ["Eigen lessen en oefeningen", "Maak je eigen lessen en oefeningen. Houd ze voor jezelf of deel ze met de trainers van je club."],
      ["Notities", "Schrijf bij elke les wat goed ging en wat je volgende keer anders doet, of houd losse notities bij."],
      ["Favorieten", "Zet een sterretje bij wat je vaak gebruikt en vind het met één tik terug."],
    ] },
];

function FeatureRow({ n, row, flip }) {
  var Visual = row.visual;
  return (
    <div style={{ display: "flex", gap: 40, flexWrap: "wrap", alignItems: "center", flexDirection: flip ? "row-reverse" : "row" }}>
      <div style={{ flex: "1 1 320px", minWidth: 0, maxWidth: 440 }}><Visual /></div>
      <div style={{ flex: "999 1 420px", minWidth: 0, display: "flex", flexDirection: "column", gap: 14 }}>
        <h3 style={{ fontSize: 24, fontWeight: 800 }}>{n + ". " + row.title}</h3>
        <p style={{ fontSize: 16, lineHeight: 1.6, color: "#4A4741" }}>{row.intro}</p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "18px 24px", marginTop: 4 }}>
          {row.features.map(function (f) {
            return (
              <div key={f[0]} style={{ flex: "1 1 40%", minWidth: 220 }}>
                <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 4 }}>{f[0]}</div>
                <p style={{ fontSize: 14, lineHeight: 1.55, color: "#4A4741" }}>{f[1]}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// page: "home" (openingsblok met inloggen) of een key uit LANDING_PAGES.
export default function Landing({ page }) {
  var p = page || "home";
  var loc = useLocation();
  var wantLogin = !!(loc.state && loc.state.login);
  useEffect(function () {
    if (p === "home" && wantLogin) { setTimeout(goToLogin, 50); return; }
    window.scrollTo(0, 0);
  }, [p, wantLogin, loc.key]);
  return (
    <div className="lp" style={{ display: "flex", flexDirection: "column" }}>
      <style>{CSS}</style>
      <Header />
      <main style={{ flex: 1 }}>
      {p === "home" && <>
      <section id="top" style={{ padding: "64px 0 80px" }}>
        <div className="lp-wrap lp-hero">
          <div style={{ flex: "999 1 480px", minWidth: 0 }}>
            <p className="lp-kick">Voor tennistrainers en tennisscholen</p>
            <h1 className="lp-h1">Elke les voorbereid.<br />Het hele seizoen.</h1>
            <p className="lp-lead" style={{ maxWidth: 540, marginBottom: 32 }}>Kant-en-klare seizoensplannen voor jeugd en volwassenen, per week en per niveau. Met alle oefeningen uitgelegd, op je telefoon, gewoon op de baan.</p>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 28 }}>
              <Link className="lp-btnp" to="/demo">Probeer de demo</Link>
              <Link className="lp-btns" to="/pakketten">Pakketten bekijken</Link>
            </div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }} aria-label="Niveaugroepen">
              <span className="lp-chip" style={{ background: "#B83232", color: "#fff" }}>Rood</span>
              <span className="lp-chip" style={{ background: "#B85A12", color: "#fff" }}>Oranje</span>
              <span className="lp-chip" style={{ background: "#2F7D47", color: "#fff" }}>Groen</span>
              <span className="lp-chip" style={{ background: "#E8C12E", color: "#2A2205" }}>Geel</span>
              <span className="lp-chip" style={{ background: "#6A4BB0", color: "#fff" }}>Volwassenen</span>
            </div>
          </div>
          <LoginCard />
        </div>
      </section>
      </>}
      {p === "hoe" && <>
      <section id="hoe" className="lp-sec lp-white">
        <div className="lp-wrap">
          <p className="lp-kick">Hoe het werkt</p>
          <h2 className="lp-h2">Van seizoen tot oefening, in een paar tikken</h2>
          <p className="lp-lead" style={{ maxWidth: 640, marginBottom: 48 }}>Je opent de week waarin je zit, kiest je groep en ziet direct wat je vandaag op de baan doet.</p>
          <div style={{ display: "flex", flexDirection: "column", gap: 64 }}>
            {HOE_ROWS.map(function (r, i) { return <FeatureRow key={r.title} n={i + 1} row={r} flip={i % 2 === 1} />; })}
          </div>
        </div>
      </section>
      </>}
      {p === "voorbeeld" && <>
      <section id="voorbeeld" className="lp-sec">
        <div className="lp-wrap" style={{ display: "flex", gap: 48, alignItems: "center", flexWrap: "wrap" }}>
          <div style={{ flex: "1 1 340px", minWidth: 0 }}>
            <p className="lp-kick">Demo</p>
            <h2 className="lp-h2">Probeer de app zelf</h2>
            <p className="lp-lead" style={{ marginBottom: 24 }}>Klik zelf door een basisversie van de app: een seizoen, een week en de oefeningen. Zonder account.</p>
            <button type="button" className="lp-btnp" disabled>Demo volgt binnenkort</button>
          </div>
          <div style={{ flex: "999 1 520px", minWidth: 0 }}>
            <div style={{ height: 380, border: "2px dashed #CFCAC0", borderRadius: 12, background: "#FAF8F4", color: "#6B675F", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 10, textAlign: "center", padding: 24, fontWeight: 600 }}>
              <svg width="40" height="40" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="#6B675F" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="6" y="2" width="12" height="20" rx="2.5" /><line x1="10" y1="18" x2="14" y2="18" /></svg>
              <span style={{ fontSize: 16, color: "#1C1B19" }}>Demo volgt</span>
              <span style={{ fontWeight: 500, maxWidth: 360, lineHeight: 1.5 }}>Hier kun je binnenkort zelf door de app klikken.</span>
            </div>
          </div>
        </div>
      </section>
      </>}
      {p === "pakketten" && <>
      <section id="pakketten" className="lp-sec lp-white">
        <div className="lp-wrap">
          <p className="lp-kick">Pakketten</p>
          <h2 className="lp-h2">Kies je pakket</h2>
          <p className="lp-lead" style={{ maxWidth: 640, marginBottom: 48 }}>Je betaalt per seizoen, per trainer. Kies je groepen, in Basic of Plus.</p>
          {TIERS.map(function (t, i) {
            return (
              <div key={t.key} style={{ marginBottom: i === 0 ? 56 : 0 }}>
                <h3 style={{ fontSize: 26, fontWeight: 800, marginBottom: 16 }}>{t.label}</h3>
                <div className="lp-grid3">
                  {GROUPS.map(function (g) { return <PackageCard key={g.key} group={g} tier={t} />; })}
                </div>
              </div>
            );
          })}
          <div style={{ marginTop: 32, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16, flexWrap: "wrap", padding: "20px 28px", border: "1px solid #E6E2D9", borderRadius: 16 }}>
            <div>
              <div style={{ fontSize: 17, fontWeight: 800 }}>Voor je hele club of tennisschool?</div>
              <div style={{ fontSize: 15, color: "#4A4741" }}>Een teamlicentie waarmee je hoofdtrainer zelf de trainers beheert.</div>
            </div>
            <Link className="lp-btns" to="/aanmelden?type=club">Club aanmelden</Link>
          </div>
        </div>
      </section>
      </>}
      {p === "wij" && <>
      <section id="wij" className="lp-sec">
        <div className="lp-wrap" style={{ display: "flex", gap: 56, flexWrap: "wrap", alignItems: "flex-start" }}>
          <div style={{ flex: "1 1 360px", minWidth: 0 }}>
            <p className="lp-kick">Wie zijn wij</p>
            <h2 className="lp-h2">Gemaakt door trainers, op de baan getest</h2>
            <p className="lp-lead" style={{ marginBottom: 16 }}>Wij geven zelf elke week les. Seizoensplan is ontstaan bij TC Atalanta, waar ons trainersteam er dagelijks mee werkt.</p>
            <p className="lp-lead">[Korte tekst: waarom jullie dit zijn begonnen en wat je trainers wilt geven.]</p>
          </div>
          <div style={{ flex: "1 1 460px", minWidth: 0, display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))", gap: 20 }}>
            <Person initials="SV" name="Sam Verweij" role="Tennistrainer · maakt de seizoensplannen" text="[Twee zinnen over Sam]" />
            <Person initials="FN" name="Floris Noordam" role="Tennistrainer · bouwt de app" text="[Twee zinnen over Floris]" />
          </div>
        </div>
      </section>
      </>}
      {p === "vragen" && <>
      <section id="vragen" className="lp-sec" style={{ background: "#fff", borderTop: "1px solid #E2DED5" }}>
        <div className="lp-wrap" style={{ maxWidth: 840 }}>
          <p className="lp-kick">Veelgestelde vragen</p>
          <h2 className="lp-h2" style={{ marginBottom: 32 }}>Goed om te weten</h2>
          {FAQ.map(function (f, i) {
            return (
              <details key={f.q} className="lp-faq" style={i === FAQ.length - 1 ? { borderBottom: "1px solid #E2DED5" } : null}>
                <summary>{f.q}</summary>
                <p>{f.a}</p>
              </details>
            );
          })}
        </div>
      </section>
      </>}
      </main>
      <footer id="contact" style={{ background: "#1C1B19", color: "#E7E3DA", padding: "48px 0" }}>
        <div className="lp-wrap" style={{ display: "flex", justifyContent: "space-between", gap: 24, flexWrap: "wrap", alignItems: "flex-start" }}>
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <Logo dark size={28} />
            <div>
              <div style={{ fontSize: 20, fontWeight: 800, color: "#fff" }}>Seizoensplan</div>
              <div style={{ fontSize: 14, color: "#B8B3A8" }}>Seizoensplannen voor tennistrainers</div>
            </div>
          </div>
          <div style={{ fontSize: 14 }}>
            Vragen? <a href={"mailto:" + CONTACT_EMAIL} style={{ color: "#E7E3DA" }}>{CONTACT_EMAIL}</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
